(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2963],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js

function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js


const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};

const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 58712:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tai-app",
      function () {
        return __webpack_require__(80677);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _utils_getFontValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84856);






// @mui

// utils

// ----------------------------------------------------------------------
var TextMaxLine = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var asLink = _param.asLink, _variant = _param.variant, variant = _variant === void 0 ? "body1" : _variant, _line = _param.line, line = _line === void 0 ? 2 : _line, _persistent = _param.persistent, persistent = _persistent === void 0 ? false : _persistent, children = _param.children, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "asLink",
        "variant",
        "line",
        "persistent",
        "children",
        "sx"
    ]);
    var lineHeight = (0,_utils_getFontValue__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(variant).lineHeight;
    var style = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: line,
        WebkitBoxOrient: "vertical"
    }, persistent && {
        height: lineHeight * line
    }, sx);
    if (asLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            color: "inherit",
            ref: ref,
            variant: variant,
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style)
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        variant: variant,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, style)
    }, other), {
        children: children
    }));
});
TextMaxLine.propTypes = {
    asLink: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node.isRequired),
    line: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().number),
    persistent: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    sx: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        "body1",
        "body2",
        "button",
        "caption",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "inherit",
        "overline",
        "subtitle1",
        "subtitle2", 
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (TextMaxLine);


/***/ }),

/***/ 80677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DownloadApp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/components/Image.js
var Image = __webpack_require__(65907);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/components/TextMaxLine.js
var TextMaxLine = __webpack_require__(90519);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/assets/index.js + 16 modules
var assets = __webpack_require__(27582);
;// CONCATENATED MODULE: ./src/sections/download/Welcome.js
// @mui




//

// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        boxShadow: "none",
        textAlign: "center",
        backgroundColor: theme.palette.primary.lighter
    }, theme.breakpoints.up("md"), {
        height: "100%",
        display: "flex",
        textAlign: "left",
        alignItems: "center",
        justifyContent: "space-between"
    });
});
// ----------------------------------------------------------------------
function Welcome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                sx: {
                    color: "grey.800",
                    p: {
                        md: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        gutterBottom: true,
                        variant: "h4",
                        children: [
                            "C\xc1C ỨNG DỤNG,",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " \xd4N THI GPLX \xd4 T\xd4, XE M\xc1Y"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pb: {
                                xs: 1,
                                xl: 2
                            },
                            mx: "auto",
                            mt: 2
                        },
                        children: "Với giao diện th\xe2n thiện v\xe0 c\xe2u hỏi được t\xf9y chỉnh theo c\xe1c chủ đề kh\xe1c nhau, ứng dụng n\xe0y cho ph\xe9p người d\xf9ng \xf4n tập kiến thức v\xe0 cải thiện sự hiểu biết về luật lệ giao th\xf4ng, biển b\xe1o, v\xe0 h\xe0nh vi an to\xe0n khi tham gia giao th\xf4ng."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets.MotivationIllustration, {
                sx: {
                    p: 1,
                    width: 200,
                    margin: {
                        xs: "auto",
                        md: "inherit"
                    }
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/tai-app.js
// next
// @mui



// layouts


// components

//




var data = [
    {
        id: 1,
        image: "oto",
        title: "THI GPLX \xd4 T\xd4 & M\xd4 PHỎNG",
        description: "T\xedch hợp c\xe1c chức năng đ\xe1nh gi\xe1 v\xe0 thống k\xea kết quả, ứng dụng thi l\xfd thuyết giấy ph\xe9p l\xe1i xe \xf4 t\xf4 cho ph\xe9p người d\xf9ng theo d\xf5i tiến độ học tập của m\xecnh v\xe0 cảm nhận sự tiến bộ từng ng\xe0y, đồng thời tăng cường sự tự tin trước khi tham gia kỳ thi thực tế.",
        ios: "https://apps.apple.com/us/app/id6461346495",
        android: "https://play.google.com/store/apps/details?id=onthibanglaixe.net.gplx"
    },
    {
        id: 2,
        image: "xemay",
        title: "THI GPLX XE M\xc1Y",
        description: "Với c\xe1c chế độ học tập linh hoạt v\xe0 cơ chế theo d\xf5i tiến độ, ứng dụng thi l\xfd thuyết giấy ph\xe9p l\xe1i xe m\xe1y gi\xfap người d\xf9ng n\xe2ng cao sự tự tin v\xe0 chuẩn bị tốt nhất cho kỳ thi giấy ph\xe9p l\xe1i xe m\xe1y",
        ios: "https://apps.apple.com/us/app/id6459738600",
        android: "https://play.google.com/store/apps/details?id=onthibanglaixe.net.xemay"
    },
    {
        id: 3,
        image: "mophong",
        title: "THI M\xd4 PHỎNG \xd4 T\xd4",
        description: "Phần mềm thi thử m\xf4 phỏng 120 t\xecnh huống giao th\xf4ng online của ch\xfang t\xf4i được ph\xe1t triển dựa tr\xean phần mềm offline do Tổng Cục Đường Bộ Việt Nam ban h\xe0nh trước đ\xf3.",
        ios: "https://apps.apple.com/us/app/id6450710245",
        android: "https://play.google.com/store/apps/details?id=onthibanglaixe.net.thimophong"
    }, 
];
// ----------------------------------------------------------------------
var tai_app_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        height: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(10)
    };
});
// ----------------------------------------------------------------------
DownloadApp.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
function DownloadApp() {
    var translate = (0,useLocales/* default */.Z)().translate;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("downloadApp.title"),
        description: translate("downloadApp.description"),
        sx: {
            height: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tai_app_RootStyle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: themeStretch ? "xl" : "lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        paragraph: true,
                        sx: {
                            textAlign: "center"
                        },
                        children: translate("downloadApp.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 2,
                        children: data.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                md: 6,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            alt: "GPLX \xd4 t\xf4",
                                                            src: "/icons/".concat(item.image, ".png"),
                                                            sx: {
                                                                height: 50,
                                                                width: 50,
                                                                mr: 1
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            children: item.title
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextMaxLine/* default */.Z, {
                                                    line: 4,
                                                    persistent: true,
                                                    variant: "body2",
                                                    children: item.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: item.android,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                alt: "Android",
                                                                src: "/icons/ic_android.jpg",
                                                                sx: {
                                                                    height: 50,
                                                                    width: 140
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: item.ios,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                alt: "IOS",
                                                                src: "/icons/ic_ios.jpg",
                                                                sx: {
                                                                    height: 50,
                                                                    width: 130
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, index);
                        })
                    })
                ]
            })
        })
    });
}
function BannerSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        mb: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            md: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Welcome, {})
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,3559,7582,9774,2888,179], function() { return __webpack_exec__(58712); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);